import { createReducer, on } from '@ngrx/store';
import { School } from '@shared/types/school.model';
import {
  clearSchoolState,
  loadSchools,
  loadSchoolsFailure,
  loadSchoolsSuccess,
  selectSchool,
} from './school.actions';

export const schoolFeatureKey = 'school';

export interface SchoolState {
  schools: School[];
  loading: boolean;
  error: string | null;
  selectedSchoolId: string | null;
}

export const initialSchoolState: SchoolState = {
  schools: [],
  loading: false,
  error: null,
  selectedSchoolId: null,
};

export const schoolReducer = createReducer(
  initialSchoolState,
  on(loadSchools, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(loadSchoolsSuccess, (state, { schools }) => ({
    ...state,
    schools,
    loading: false,
    error: null,
  })),
  on(loadSchoolsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(selectSchool, (state, { schoolId }) => ({
    ...state,
    selectedSchoolId: schoolId,
  })),
  on(clearSchoolState, () => initialSchoolState)
);
